<template>
    <!-- <b-modal title="Scheda Psicologica" ref="mdlRsaSchedaPsicologica" @ok="onSalvaSchedaPsicologica" @hidden="onCloseModal" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg"> -->
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Valutazione" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Motivo del ricovero</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.motivoRicovero }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.motivoRicovero" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Patologie neurodegenerative/cerebrolesioni acquisite</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.patologieNeurodegenerative }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.patologieNeurodegenerative" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Diagnosi Psichiatrica</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.diagnosiPsichiatrica }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.diagnosiPsichiatrica" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Altri possibili sintomi/disturbi comportamentali</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.altriPossibiliSintomiDisturbiComportamentali }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.altriPossibiliSintomiDisturbiComportamentali" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Aspetto e cura del sè</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.aspettoCuraSe }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.aspettoCuraSe" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Comportamento verso l'Operatore</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.comportamentoVersoOperatore }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.comportamentoVersoOperatore" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Livello di vigilanza</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.livelloVigilanza }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.livelloVigilanza" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Comportamento e Attività Psicomotoria</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.comportamentoAttivitaPsicomotoria }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.comportamentoAttivitaPsicomotoria" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Orientamento</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.orientamento }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.orientamento" :disabled="isReadOnly" :options="orientamentoOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione Orientamento</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.orientamentoDescrizione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.orientamentoDescrizione" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Capacità Cognitive</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.capacitaCognitive }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.capacitaCognitive" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Capacità di Giudizio e Insight</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.capacitaGiudizioInsight }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.capacitaGiudizioInsight" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Linguaggio</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.linguaggio }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.linguaggio" :disabled="isReadOnly" :options="linguaggioOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione Linguaggio</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.linguaggioDescrizione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.linguaggioDescrizione" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Percezione</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.percezione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.percezione" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Contenuto del Pensiero</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.contenutoPensiero }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.contenutoPensiero" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Umore</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.umore }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.umore" :disabled="isReadOnly" :options="umoreOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione Umore</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.umoreDescrizione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.umoreDescrizione" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Affettività</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.affettivita }}</span>
                        <b-form-select v-else v-model="jsonDataSchedaPsicologica.affettivita" :disabled="isReadOnly" :options="affettivitaOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione Affettività</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.affettivitaDescrizione }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.affettivitaDescrizione" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Familiari/persone di riferimento</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.familiariPersoneRiferimenti }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.familiariPersoneRiferimenti" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Problemi sociali segnalati</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.problemiSocialiSegnalati }}</span>
                        <b-form-input v-else v-model="jsonDataSchedaPsicologica.problemiSocialiSegnalati" :readonly="isReadOnly"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span v-if="isReadOnly">{{ jsonDataSchedaPsicologica.note }}</span>
                        <b-form-textarea v-else v-model="jsonDataSchedaPsicologica.note" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlRsaSchedaPsicologica.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaSchedaPsicologica()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlRsaSchedaPsicologica.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
        jsonDataSchedaPsicologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    diagnosiPsichiatrica: "",
                    aspettoCuraSe: "",
                    condizioniIgieniche: "",
                    comportamentoAttivitaPsicomotoria: "",
                    comportamentoVersoOperatore: "",
                    percezione: "",
                    contenutoPensiero: "",
                    capacitaCognitive: "",
                    capacitaGiudizioInsight: "",
                    umore: null,
                    umoreDescrizione: "",
                    affettivita: null,
                    affettivitaDescrizione: "",
                    linguaggio: null,
                    linguaggioDescrizione: "",
                    orientamento: null,
                    orientamentoDescrizione: "",
                    note: "",
                    altriPossibiliSintomiDisturbiComportamentali: "",
                    familiariPersoneRiferimenti: "",
                    livelloVigilanza: "",
                    patologieNeurodegenerative: "",
                    problemiSocialiSegnalati: "",
                    motivoRicovero: "",
                };
            },
        },
    },
    mounted() {
        let me = this;

        if (me.idRisorsa != null) {
            me.visualizzaSchedaPsicologica();
        }
    },
    watch: {
        jsonDataSchedaPsicologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaPsicologica: "/rsaschedapsicologica",
            pathResourceCheckSchedaPsicologica: "/rsaschedapsicologica/check",
            umoreOptions: [
                { text: "EUTIMICO", value: "EUTIMICO" },
                { text: "DEFLESSO", value: "DEFLESSO" },
                { text: "DISFORICO", value: "DISFORICO" },
                { text: "EUFORICO", value: "EUFORICO" },
            ],
            affettivitaOptions: [
                { text: "NORMALE", value: "NORMALE" },
                { text: "LIMITATA", value: "LIMITATA" },
                { text: "COARTATA", value: "COARTATA" },
                { text: "APPIATTITA", value: "APPIATTITA" },

                { text: "ALTRO", value: "ALTRO" },
            ],
            linguaggioOptions: [
                { text: "FLUENTE", value: "FLUENTE" },
                { text: "MUTISMO", value: "MUTISMO" },
                { text: "ECOLALIA", value: "ECOLALIA" },
                { text: "POVERTA' ESPRESSIVA", value: "POVERTA' ESPRESSIVA" },
                { text: "LOGORREA", value: "LOGORREA" },
                { text: "ALTRO", value: "ALTRO" },
            ],
            orientamentoOptions: [
                { text: "PRESENTE", value: "PRESENTE" },
                { text: "ASSENTE", value: "ASSENTE" },
                { text: "PARZIALE", value: "PARZIALE" },
                { text: "DISORIENTAMENTO NEL TEMPO", value: "DISORIENTAMENTO NEL TEMPO" },
                { text: "DISORIENTAMENTO NELLO SPAZIO", value: "DISORIENTAMENTO NELLO SPAZIO" },
                { text: "DISORIENTAMENTO VERSO IL SE", value: "DISORIENTAMENTO VERSO IL SE" },
                { text: "DISORIENTAMENTO VERSO LE PERSONE", value: "DISORIENTAMENTO VERSO LE PERSONE" },
            ],
            /*  jsonDataSchedaPsicologica: {
                id: null,
                idAccettazione: null,
                diagnosiPsichiatrica: null,
                aspettoFisico: null,
                condizioniIgieniche: null,
                curaNelVestirsi: null,
                comportamentoAttivitaPsicomotoria: null,
                comportamentoVersoOperatore: null,
                percezione: null,
                contenutoPensiero: null,
                capacitaCognitive: null,
                capacitaGiudizioInsight: null,
                umore: null,
                umoreDescrizione: null,
                affettivita: null,
                affettivitaDescrizione: null,
                linguaggio: null,
                linguaggioDescrizione: null,
                orientamento: null,
                orientamentoDescrizione: null,
                note: null,
            },
            isReadOnly: false, */
        };
    },

    methods: {
        /* nuovaSchedaPsicologica() {
            let me = this;
            me.isReadOnly = false;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaPsicologica, { idAccettazione: me.idAccettazione }, me.loadSchedaPsicologicaDataSuccess, me.loadSchedaPsicologicaDataError);
        },
        loadSchedaPsicologicaDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list?.length > 0) {
                me.jsonDataSchedaPsicologica = response.data.data.list[0];
            } else {
                me.jsonDataSchedaPsicologica = {
                    id: null,
                    idAccettazione: me.idAccettazione,
                    diagnosiPsichiatrica: null,
                    aspettoFisico: null,
                    condizioniIgieniche: null,
                    curaNelVestirsi: null,
                    comportamentoAttivitaPsicomotoria: null,
                    comportamentoVersoOperatore: null,
                    percezione: null,
                    contenutoPensiero: null,
                    capacitaCognitive: null,
                    capacitaGiudizioInsight: null,
                    umore: null,
                    umoreDescrizione: null,
                    affettivita: null,
                    affettivitaDescrizione: null,
                    linguaggio: null,
                    linguaggioDescrizione: null,
                    orientamento: null,
                    orientamentoDescrizione: null,
                    note: null,
                };
            }
            // me.$refs.mdlRsaSchedaPsicologica.show();
        },
        loadSchedaPsicologicaDataError(error) {
            let me = this;
            console.error("Errore nel caricamento:", error);
            me.$bvToast.toast("Errore nel caricamento dei dati nel edit component", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
 */
        visualizzaSchedaPsicologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaPsicologica + "/" + me.idRisorsa, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            /* me.jsonDataSchedaPsicologica = response.data.data; */
            Object.keys(response.data.data).forEach((key) => {
                me.jsonDataSchedaPsicologica[key] = response.data.data[key];
            });
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        /*   onCloseModal() {
            let me = this;
            me.jsonDataSchedaPsicologica = {};
            me.$emit("onClose");
        }, */
        onSalvaSchedaPsicologica() {
            let me = this;
            if (!me.jsonDataSchedaPsicologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaPsicologica, me.jsonDataSchedaPsicologica, me.saveSchedaPsicologicaSuccessResponse, me.saveSchedaPsicologicaErrorResponse);
        },
        saveSchedaPsicologicaSuccessResponse() {
            let me = this;
            me.$emit("afterSaveSuccess");
            me.$refs.mdlRsaSchedaPsicologica.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveSchedaPsicologicaErrorResponse(response) {
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-secondary",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                this.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
    },
};
</script>
